
import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { useToast } from "@/hooks/use-toast";
import { MentorApplication } from "./MentorTypes";

export const useMentorApplications = () => {
  const [applications, setApplications] = useState<MentorApplication[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  const fetchMentorApplications = async () => {
    try {
      setLoading(true);
      
      const { data, error } = await supabase
        .from('mentors')
        .select(`
          *,
          profile:profiles(full_name, avatar_url)
        `)
        .order('created_at', { ascending: false });
        
      if (error) {
        console.error("Error fetching mentor applications:", error);
        setApplications([]);
        return;
      }
      
      setApplications(data as MentorApplication[]);
    } catch (error) {
      console.error("Error fetching mentor applications:", error);
      setApplications([]);
    } finally {
      setLoading(false);
    }
  };
  
  const updateApplicationStatus = async (id: string, status: 'approved' | 'rejected') => {
    try {
      const { error } = await supabase
        .from('mentors')
        .update({ status })
        .eq('id', id);
        
      if (error) {
        console.error(`Error ${status} application:`, error);
        return;
      }
      
      setApplications(applications.map(app => 
        app.id === id ? { ...app, status } : app
      ));
      
      toast({
        title: `Application ${status}`,
        description: `The mentor application has been ${status}`,
      });
    } catch (error) {
      console.error(`Error ${status} application:`, error);
    }
  };

  return {
    applications,
    loading,
    fetchMentorApplications,
    updateApplicationStatus
  };
};
